module.exports = __webpack_public_path__ + "img/ic-arrow-s.0707b0dc.svg";